import { render, staticRenderFns } from "./TagCreate.vue?vue&type=template&id=07b248a4&"
import script from "./TagCreate.vue?vue&type=script&lang=ts&"
export * from "./TagCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports